/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Error_LoadInputs */



/**
* | output |
* | --- |
* | "Couldn't load the community directory." |
*
* @param {Community_Error_LoadInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_error_load = /** @type {((inputs?: Community_Error_LoadInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Error_LoadInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger l'annuaire de la communauté.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar el directorio de la comunidad.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível carregar o diretório da comunidade.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare l'elenco della comunità.")
	return /** @type {LocalizedString} */ ("Couldn't load the community directory.")
});